<template>
<loader v-bind="{ loading }">
  <div class="columns">
    <div class="column">
      <p>There is {{ environments.total }} environment<span v-if="environments.total !== 1">s</span> on {{ app.name }} ({{ app.domain }})</p>
    </div>
    <div class="column is-narrow">
      <router-link
        v-if="$root.can('create_environments', app.account_id)"
        class="is-flex"
        :to="{
          name: 'new-app-environment',
          params: {
            app: $route.params.app
          }
        }">
        <icon icon="plus"/>
        <span>Environment</span>
      </router-link>
    </div>
  </div>
  <div class="columns">
    <div class="column">
      <index-row
        v-for="environment in environments.data" :key="environment.id"
        :title="environment.name"
        :route="{
          name: 'environment-manager',
          params: {
            environment: environment.id,
            app: environment.app_id,
        }}">
        <p class="help">Last Active {{ environment.updated_at | asCalendar }}</p>

        <template #right>
          <flex width="10%" min-width="100px" class="align-center" column>
            <p>
              <icon class="laravel-icon has-text-danger" icon="laravel" type="fab"/>
            </p>
            <laravel-version class="mr" :software="environment.software"/>
          </flex>
          <flex width="10%" min-width="100px" class="align-center" column>
            <icon icon="git" type="fab"/>
            <git-branch class="mr" :attributes="environment.attributes"/>
          </flex>
          <flex width="10%" min-width="100px" class="align-center" column>
            <problems column :count="environment.unresolved_findings_count"/>
          </flex>
        </template>
      </index-row>
    </div>
  </div>
</loader>
</template>

<script>
import { mapGetters } from 'vuex'
import Paginator from '@/store/models/Paginator'
import { getPath } from '@/api/common'

export default {

  data: () => ({
    loading: true,
    environments: new Paginator()
  }),

  beforeCreate() {
    this.$bus.$emit('set-title', 'Environments')
  },

  created() {
    getPath({
      path: 'api' + this.$route.fullPath
    }, ({data}) => {
      this.environments = data
      this.loading = false
    })
  },

  computed: {
    ...mapGetters('app', [
      'app'
    ])
  }
}
</script>
